<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--名称-->
      <el-form-item label="选中数量" :label-width="formLabelWidth">
        <p class="red f20">{{ formData.ids.length || '暂无选中记录' }}</p>
      </el-form-item>

      <el-form-item label="所属分类：" :label-width="formLabelWidth">
        <el-select v-model="formData.category_id">
          <template v-for="cat in category">
            <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
            <template v-if="cat.child !== undefined">
              <template v-for="two in cat.child">
                <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
                <template v-if="two.child !== undefined">
                  <template v-for="three in two.child">
                    <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
                  </template>
                </template>
              </template>
            </template>
          </template>
        </el-select>
      </el-form-item>

      <el-form-item label="产品状态" prop="product_status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.product_status">
          <el-radio :label="10">上架</el-radio>
          <el-radio :label="20">下架</el-radio>
          <el-radio :label="30">草稿</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否新品" prop="is_new" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_new">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否热卖" prop="is_hot" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_hot">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否推荐" prop="is_recommend" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_recommend">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="初始销量" prop="sales_initial" :label-width="formLabelWidth">
        <el-input v-model="formData.sales_initial" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item>

      <el-form-item label="一口价" prop="product_price" :label-width="formLabelWidth">
        <el-input v-model="formData.product_price" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item>
      
      <el-form-item label="总库存" prop="product_stock" :label-width="formLabelWidth">
        <el-input v-model="formData.product_stock" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item>

      <el-form-item label="排序" prop="product_sort" :label-width="formLabelWidth">
        <el-input v-model="formData.product_sort" placeholder="请输入" type="number" style="width:120px"></el-input>
        <span class="gray9">数字越小越靠前</span>
      </el-form-item>

      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PorductApi from '@/api/product.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        ids: [],
        category_id: '',
        product_status: '',
        is_new: '',
        is_hot: '',
        is_recommend: '',
        sales_initial: '',
        product_price: '',
        product_stock: '',
        product_sort: '',
        is_delete: '',
      },
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids', 'category'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          PorductApi.batch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/batch.vue